import Vue from 'vue'
import socialMediaChannelApi from '@/api/socialMediaChannel.api'

const state = {
  socialMediaChannels: {}
}


const getters = {
  socialMediaChannelById: (state) => (id) => {
    return state.socialMediaChannels[id]
  },

  socialMediaChannelsById: (state, getters) => (id) => {
    return getters.socialMediaChannels.filter(x => x.socialMediaId === id)
  },

  socialMediaChannels: (state) => {
    return Object.values(state.socialMediaChannels).filter(x => x.socialMediaId === 2)
  }
}


const actions = {
  async loadSocialMediaChannels ({ commit, rootState }) {
    const response = await socialMediaChannelApi.getSocialMediaChannels(rootState.tenant.current)
    commit('SET_SOCIAL_MEDIA_CHANNELS', response.data)
  },

  // async loadChannelByChannelData ({ commit, rootState }, channelData) {
  //   const response = await socialMediaChannelApi.getSocialMediaChannel(rootState.tenant.current, channelData.id)
  //   commit('UPDATE_SOCIAL_MEDIA_CHANNEL', response.data)
  //   return response.data
  // },
  //
  // async updateChannelByChannelData ({ commit, rootState }, channelData) {
  //   commit('UPDATE_SOCIAL_MEDIA_CHANNEL', channelData)
  //   return response.data
  // },

  async loadAndUpdateChannel ({ commit, rootState }, entityData) {
    const response = await socialMediaChannelApi.getSocialMediaChannel(rootState.tenant.current, entityData.id)
    commit('UPDATE_SOCIAL_MEDIA_CHANNEL', response.data)
    return response.data
  },

  async createSocialMediaChannel ({ commit, rootState }, socialMediaChannel) {
    const response = await socialMediaChannelApi.createSocialMediaChannel(rootState.tenant.current, socialMediaChannel)
    commit('CREATE_SOCIAL_MEDIA_CHANNEL', response.data)
    return response.data
  },

  async updateSocialMediaChannel ({ commit, rootState }, socialMediaChannel) {
    const response = await socialMediaChannelApi.updateSocialMediaChannel(rootState.tenant.current, socialMediaChannel.id, socialMediaChannel)
    commit('UPDATE_SOCIAL_MEDIA_CHANNEL', response.data)
    return response.data
  },

  async deleteSocialMediaChannel ({ commit, rootState }, id) {
    await socialMediaChannelApi.deleteSocialMediaChannel(rootState.tenant.current, id)
    commit('DELETE_SOCIAL_MEDIA_CHANNEL', id)
  }
}


const mutations = {
  SET_SOCIAL_MEDIA_CHANNELS (state, socialMediaChannels) {
    state.socialMediaChannels = {}
    for (const socialMediaChannel of socialMediaChannels) {
      Vue.set(state.socialMediaChannels, socialMediaChannel.id, socialMediaChannel)
    }
  },

  CREATE_SOCIAL_MEDIA_CHANNEL (state, socialMediaChannel) {
    Vue.set(state.socialMediaChannels, socialMediaChannel.id, socialMediaChannel)
  },

  UPDATE_SOCIAL_MEDIA_CHANNEL (state, socialMediaChannel) {
    Vue.set(state.socialMediaChannels, socialMediaChannel.id, socialMediaChannel)
  },

  DELETE_SOCIAL_MEDIA_CHANNEL (state, id) {
    Vue.delete(state.socialMediaChannels, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
